/*
 * @Author       : LiYang
 * @Date         : 2021-11-23 11:23:39
 * @LastEditTime : 2022-03-14 20:34:10
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

export let zIndex = 1000

export const getIndex = () => zIndex

export const upDateIndex = () => zIndex++